module.exports = __webpack_public_path__ + "socicon.9a64ef938f9e55a70a4d.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Users/TerrellDavis/Documents/GitHub/AVL/realavl/realavl/src/fonts/socicon.ttf
// module id = ../../../../../src/fonts/socicon.ttf
// module chunks = styles